import { loadAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './runtimeRemotes';

const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'REPORTING_API_URL',
  'SYSTEM_SETTINGS_API_URL',
  'MFE_ROOT_ROUTE',
];

/** Loads settings, validates required keys, and registers runtime remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter((key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim());

  if (missing.length) {
    throw new Error(`[reporting_ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  if (!registerRuntimeRemotes(appSettings)) {
    throw new Error(`[reporting_ui] cannot ${action}: failed to register required runtime remotes`);
  }
}

/** Mounts the app into the supplied host element. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
